// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1-Xf4","inputWrap":"styles_inputWrap__567Y0","input":"styles_input__1qZZ_"};